<template>
  <div
    v-if="value"
    style="width: 100%"
  >
    <v-col cols="12">
      <app-title texto="RESUMO DOS FILTROS" />
    </v-col>
    <v-col
      v-for="(r, i) in value"
      :key="i"
    >
      <resumo
        v-if="r.habilitado"
        :titulo="r.titulo"
        :value="r"
        :headers="r.headers"
      />
    </v-col>
  </div>
</template>

<script>
import AppTitle from '@/components/core/AppTitle';
import Resumo from '@/components/monitoramento/perfil/filtro/base/Resumo';

export default {
  name: 'ResumoFiltroBusca',

  components: { AppTitle, Resumo },

  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
